import { Alert, Input, InputProps } from "@fluentui/react-northstar";
import { FieldDescriptor } from "@shopify/react-form-state";
import React from "react";

import { FieldLabel, FieldLabelProps } from ".";

type Props = {
  label?: React.ReactNode;
  field: FieldDescriptor<string> | FieldDescriptor<number>;
  labelProps?: Partial<FieldLabelProps>;
  style?: React.CSSProperties;
  tooltip?: React.ReactNode;
  className?: string;
} & InputProps;

export const TextInputField: React.FC<Props> = ({
  field,
  label,
  style,
  className,
  tooltip,
  labelProps,
  ...inputProps
}) => {
  if (field === undefined) {
    throw new Error(`Invalid field for TextInputField ${className} ${label}`);
  }

  return (
    <div style={style} className={className}>
      {label && (
        <FieldLabel
          label={label}
          tooltip={tooltip}
          size="medium"
          disabled={inputProps.disabled}
          {...labelProps}
        />
      )}
      <Input
        onChange={e => {
          const newValue = (e.currentTarget as HTMLInputElement).value;
          if (newValue !== field.value) {
            field.onChange((newValue as any) || "");
          }
        }}
        styles={{ marginTop: label ? ".25rem" : undefined, opacity: inputProps.disabled ? 0.5 : 1 }}
        value={field.value}
        id={field.name}
        {...inputProps}
        wrapper={
          field.error
            ? {
                styles: {
                  border: "1px solid red",
                },
              }
            : undefined
        }
      />
      {field.error && <Alert content={field.error} danger attached="bottom" />}
    </div>
  );
};
